import TermsAndConditions from 'components/pages/TermsAndConditions';
import HomePage from 'components/pages/HomePage';
import { oldSelfServiceLink } from 'config';
import IframePage from 'components/core/IFramePage';
import CustomerDetailsRedirect from 'components/pages/CustomerDetailsRedirect';
import SuspensionRuleList from 'components/pages/SuspensionRules/List';
import SuspensionRuleDetail from 'components/pages/SuspensionRules/Detail/SuspensionRuleDetail';
import SsoGroupList from 'components/pages/SsoGroupManangement/List';
import SsoGroupEdit from 'components/pages/SsoGroupManangement/Edit';
import SsoGroupAdd from 'components/pages/SsoGroupManangement/Add';
import customerRoutes from './customerRoutes';

// Must be in decreasing order of the path length. Must use arrays for nested paths or can mess up the bread crumbs.
const layoutRoutes = [
  {
    path: '/',
    exact: true,
    component: HomePage,
    ignoreForBreadCrumb: true,
  },
  {
    path: '/Terms',
    component: TermsAndConditions,
  },
  {
    path: '/Customers',
    component: customerRoutes,
  },
  {
    path: '/Customer/Detail',
    component: CustomerDetailsRedirect,
  },
  {
    path: '/Reports',
    frameSrc: oldSelfServiceLink + '/Reports/Home',
    component: IframePage,
  },
  {
    path: '/OmgSettings',
    frameSrc: oldSelfServiceLink + '/OMG/OmgSettings/List',
    component: IframePage,
  },
  {
    path: '/BrandTemplates',
    frameSrc: oldSelfServiceLink + '/OMG/BrandTemplates/List',
    component: IframePage,
  },
  {
    path: '/AccountTemplates',
    frameSrc: oldSelfServiceLink + '/OMG/AccountTemplates/List',
    component: IframePage,
  },
  {
    path: '/BulkBusinessIdUpdate',
    frameSrc: oldSelfServiceLink + '/BulkAccountUpdates/Upload',
    component: IframePage,
    breadCrumbName: 'Bulk BusinessId Update',
  },
  {
    path: '/InvoiceUpload',
    frameSrc: oldSelfServiceLink + '/CustomerInvoice/Upload',
    component: IframePage,
  },
  {
    path: '/UploadCCBuckets',
    frameSrc: oldSelfServiceLink + '/Service/UploadCCBuckets',
    component: IframePage,
  },
  {
    path: '/Forms',
    frameSrc: oldSelfServiceLink + '/Document/List',
    component: IframePage,
  },
  {
    path: '/UserManagement',
    frameSrc: oldSelfServiceLink + '/Administration/WebUsersManager',
    component: IframePage,
    breadCrumbName: 'User Management',
  },
  {
    path: '/GroupManagement',
    frameSrc:
      oldSelfServiceLink + '/Administration/WebGroupsManager?uid={#userId}',
    component: IframePage,
    breadCrumbName: 'Group Management',
  },
  {
    path: '/Settings',
    frameSrc: oldSelfServiceLink + '/Administration/Settings',
    component: IframePage,
  },
  {
    path: '/SuspensionRules/:facilityAccountId/Edit',
    component: SuspensionRuleDetail,
  },
  {
    path: '/SuspensionRules',
    component: SuspensionRuleList,
    breadCrumbName: 'Suspension Rules',
  },
  {
    path: '/SsoGroupManagement/Add',
    component: SsoGroupAdd,
  },
  {
    path: '/SsoGroupManagement/:ssoGroupId/Edit',
    component: SsoGroupEdit,
  },
  {
    path: '/SsoGroupManagement',
    component: SsoGroupList,
    breadCrumbName: 'SSO Group Management',
  },
  {
    path: '/MyProfile',

    frameSrc:
      oldSelfServiceLink +
      '/Administration/WebUserProfile/Edit?userId={#userId}',
    component: IframePage,
  },
  {
    path: '/MySettings',
    frameSrc:
      oldSelfServiceLink +
      '/Administration/WebUserProfile/EditUserSettings?userId={#userId}',
    component: IframePage,
  },
  {
    path: '/Help',
    frameSrc: oldSelfServiceLink + '/Help/List',
    component: IframePage,
  },
  {
    path: '/',
    component: HomePage,
    ignoreForBreadCrumb: true,
  }, //all other route will be redirected to route, has to be last one
];

export default layoutRoutes;
